import { addCopilotContext as e, addCopilotInstruction as t, addCopilotTool as n } from "../global-state.js";
import { useCallback as r, useEffect as i, useRef as a } from "react";
// src/react/global-state.ts
function o(e) {
	let n = e.isEnabled ?? !0, r = "session" in e, a = e.session ?? null;
	return i(() => {
		if (n === !1 || r && a == null) return;
		let i = a == null ? t(e) : a.addInstruction({ instruction: e.instruction });
		return () => i();
	}, [
		n,
		r,
		a,
		e.instruction
	]);
}
function s(e) {
	let t = e.isEnabled ?? !0, r = "session" in e, o = e.session ?? null, s = e.type === "client" && e.humanInTheLoop !== !0 ? e.handler : void 0, c = a(s);
	c.current = s;
	let l = e.type === "server" ? e.handler : void 0, u = a(l);
	u.current = l;
	let d = s != null || l != null, f = a(e.render);
	f.current = e.render;
	let p = e.render != null, m = a(e.needsApproval);
	m.current = e.needsApproval;
	let h = e.needsApproval != null, g = e.humanInTheLoop === !0;
	return i(() => {
		if (t === !1 || r && o == null) return;
		let i = o == null ? n : (e) => o.addTool(e), a = {
			name: e.name,
			description: e.description,
			requestSchema: e.requestSchema,
			responseSchema: e.responseSchema,
			needsApproval: h ? (e) => typeof m.current == "function" ? m.current(e) : m.current === !0 : void 0,
			render: p ? (e) => f.current?.(e) : void 0
		}, s = i(e.type === "client" ? g ? {
			...a,
			type: e.type,
			humanInTheLoop: !0,
			render: (e) => f.current?.(e)
		} : {
			...a,
			type: e.type,
			handler: (e) => c.current?.(e)
		} : {
			...a,
			type: e.type,
			handler: (e) => u.current?.(e),
			isStreaming: e.isStreaming
		});
		return () => s();
	}, [
		t,
		r,
		o,
		e.type,
		e.name,
		e.description,
		e.requestSchema,
		e.responseSchema,
		h,
		g,
		"isStreaming" in e && e.isStreaming,
		d,
		p
	]);
}
function c(t) {
	let n = t.isEnabled ?? !0, o = "session" in t, s = t.session ?? null, c = a(t);
	c.current = t;
	let l = r(() => typeof c.current.value == "function" ? c.current.value() : c.current.value, []);
	return i(() => {
		if (n === !1 || o && s == null) return;
		let r = {
			description: t.description,
			value: l
		}, i = s == null ? e(r) : s.addContext(r);
		return () => i();
	}, [
		n,
		o,
		s,
		t.description
	]);
}
export { c as useCopilotContext, o as useCopilotInstruction, s as useCopilotTool };
